import { makeStyles } from '@material-ui/core/styles'
import SwitchBase from '../../1elements/SwitchBase'
import { Text } from '../../1elements'
import Colors from '../../../styling/Colors'

const DataVisibilitySwitch = ({ onChange, checked }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Text type='dataVisibilitySwitchLabel'><span className={!checked ? classes.bold : undefined}>My Approval</span></Text>
      <SwitchBase onChange={onChange} checked={checked} />
      <Text type='dataVisibilitySwitchLabel'><span className={checked ? classes.bold : undefined}>All Approval</span></Text>
    </div>
  )
}

export default DataVisibilitySwitch

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '210px'
  },
  bold: {
    color: Colors.TEXT, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    fontWeight: 600
  }
})
